export default function scrollToElement(elementId: string, offset = 0) {
  const el = document.querySelector(elementId) as HTMLElement;
  if (!el) return;
  const distance = (el.offsetTop - offset) as number;
  window.scrollTo({
    top: distance,
    left: 0,
    behavior: "smooth"
  });
}
